import { useTranslation } from "react-i18next";

import { BannerType, BannerView } from "@dotnet/telematics-design-system";

import { FileDeletedProps } from "./types";

const FileDeleted = ({ isSubtitle, customCss }: FileDeletedProps) => {
    const { t } = useTranslation();

    return (
        <BannerView
            bannerType={BannerType.Warning}
            title={t("General##file deleted")}
            css={[
                isSubtitle
                    ? {
                          padding: "3px 7px",
                          whiteSpace: "nowrap"
                      }
                    : {},
                customCss
            ]}
        />
    );
};

export default FileDeleted;
